import { useTranslation } from 'react-i18next';

import { TextField } from 'fields';

import type { IBusinessContact } from './types';

export default function BusinessContact({ disabled }: IBusinessContact) {
  const { t } = useTranslation('CreateOrder');

  return (
    <TextField
      required
      disabled={disabled}
      name="businessUser.contactNumber"
      label={t('ProductForm.labels.businessContact')}
      placeholder={t('ProductForm.placeholders.businessContact')}
    />
  );
}
